import { IImage } from '@faire/web-api--source/indigofair/data/IImage';
import { ITestimonialTranslation } from '@faire/web-api--source/indigofair/data/ITestimonialTranslation';
import { ISO3166Alpha3 } from '@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3';
import { Language } from '@faire/web-api--source/indigofair/languages/Language';

export namespace ITestimonial {
  export enum Type {
    NET_TERMS_HUB_DEFAULT = 'NET_TERMS_HUB_DEFAULT',
    LAUNCH_WITH_FAIRE = 'LAUNCH_WITH_FAIRE',
    POS_HUB = 'POS_HUB',
    BRAND = 'BRAND',
    OPEN_WITH_FAIRE_NORTH_AMERICA = 'OPEN_WITH_FAIRE_NORTH_AMERICA',
  }

  /**
   * Return an instance of ITestimonial with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ITestimonial>): ITestimonial =>
    ({
      testimonial_translations: [],
      allowed_countries: [],
      allowed_languages: [],
      ...(partial ?? {}),
    }) as ITestimonial;
}

export interface ITestimonial {
  token: string | undefined;
  /**
   * @deprecated
   */
  image_url: string | undefined;
  title: string | undefined;
  testimony: string | undefined;
  author: string | undefined;
  retailer_name: string | undefined;
  type: keyof typeof ITestimonial.Type | undefined;
  version: number | undefined;
  priority: number | undefined;
  image: IImage | undefined;
  image_text: string | undefined;
  link_url: string | undefined;
  link_text: string | undefined;
  country: keyof typeof ISO3166Alpha3 | undefined;
  video_url: string | undefined;
  brand_name: string | undefined;
  /**
   * This image is used to allow brands/retailers to upload a feature image
   */
  testimonial_image: IImage | undefined;
  /**
   * Used when adding a testimonial to manually add human translation
   */
  testimonial_translations: Array<ITestimonialTranslation>;
  /**
   * An empty list means all countries are allowed
   */
  allowed_countries: Array<keyof typeof ISO3166Alpha3>;
  /**
   * An empty list means all languages are allowed
   */
  allowed_languages: Array<keyof typeof Language>;
}
